export const getElementSubscriberForUser = (list: any[], userId: string | number) => {
  if (list?.length > 0) return list?.find((ele: any) => +ele.userId === +userId)
  return null
}
